import Axios, { AxiosResponse } from "axios"
import {
  AssignmentGroupQueryState,
  AssignmentGroupResponse,
  AssignmentProjectQueryState,
  AssignmentProjectResponse,
  UserQueryState,
  UserResponse,
} from "./user.type"

export const getAllUserMiddleware = async (params: UserQueryState) => {
  try {
    const response: AxiosResponse<{
      data: UserResponse[]
      total: number
      user_limit: number
      label_limit: string
    }> = await Axios.get(`/api/user/list`, {
      params,
    })
    return {
      data: response.data.data,
      total: response.data.total,
      userLimit: response.data.user_limit,
      labelLimit: response.data.label_limit,
    }
  } catch (error) {
    return {
      data: [],
      total: 0,
      userLimit: 0,
      labelLimit: "",
    }
  }
}

export const getAllRoleMiddleware = async () => {
  try {
    const response: AxiosResponse<{
      data: {
        id: string
        name: string
        description: string
      }[]
      total: number
    }> = await Axios.get(`/api/user/org-roles`)
    return {
      data: response.data.data,
      total: response.data.total,
    }
  } catch (error) {
    return {
      data: [],
      total: 0,
    }
  }
}

export const updateUserRoleMiddleware = async (
  userId: string,
  roleId: string,
  isTransferOwner = false
) => {
  return Axios.put(`/api/user/change-role/${userId}`, {
    role_id: roleId,
    is_transfer_owner: isTransferOwner,
  })
}

export const updateUserBlockMiddleware = async (userId: string) => {
  return Axios.post(`/api/organization/toggle-user-block`, { user_id: userId })
}

export const postInviteMemberMiddleware = async (
  email: string,
  roleId: string
) => {
  return Axios.post(`/api/user/organization/invite-member?loading=0`, {
    email: email,
    role_id: roleId,
  })
}

export const checkEmailExistsMiddleware = async (email: string) => {
  try {
    const response: AxiosResponse<{
      data: {
        existInWorkspace: boolean
        existInSystem: boolean
      }
      statusCode: number
    }> = await Axios.get(`/api/user/check-email-exists?loading=0`, {
      params: {
        email,
      },
    })
    return response.data.data
  } catch (error) {
    return null
  }
}

export const removeUserInWorkspaceMiddleware = async (userId: string) => {
  return Axios.delete(`/api/user/${userId}/remove-from-workspace`)
}

export const getAssignmentGroupByUserIdMiddleware = async (
  params: AssignmentGroupQueryState,
  user_id: string
) => {
  try {
    const response: AxiosResponse<{
      data: AssignmentGroupResponse[]
      total: number
      totalLabel: string
    }> = await Axios.get(`/api/group-organization/user/${user_id}/groups`, {
      params,
    })
    return {
      data: response.data.data,
      total: response.data.total,
      totalLabel: response.data.totalLabel,
    }
  } catch (error) {
    return {
      data: [],
      total: 0,
      totalLabel: "",
    }
  }
}

export const getAssignmentProjectByUserIdMiddleware = async (
  params: AssignmentProjectQueryState,
  user_id: string
) => {
  try {
    const response: AxiosResponse<{
      data: AssignmentProjectResponse[]
      total: number
      totalLabel: string
    }> = await Axios.get(`/api/group-organization/user/${user_id}/projects`, {
      params,
    })
    return {
      data: response.data.data,
      total: response.data.total,
      totalLabel: response.data.totalLabel,
    }
  } catch (error) {
    return {
      data: [],
      total: 0,
      totalLabel: "",
    }
  }
}
